define(['jquery', 'forms', 'masking'], function ($, Forms, Masking) {
	var Expatriate = function() {
		var self = this;

		self.forms = new Forms();
		self.$ervBody = $('#erv-body');
		self.$form = $('.expatriatepage form[data-js-mainform]');

		self.deleteAge = function ($age) {
			var deletedIndex = $age.data('id');
			$age.remove();
			self.refreshAges(deletedIndex);
			return deletedIndex;
		};
		
		self.refreshAges = function (deletedIndex) {
			var $allAdded = self.$ageList.find('.age.added');
			var $allNext = $allAdded.filter(function () {
				return ($(this).data('id') > deletedIndex); 
			});

			$allNext.each(function () {
				var $age = $(this);
				var index = $age.data('id'),
					newIndex = (index - 1);

				$age.find('.index').text(index);
				$age.data('id', newIndex);

				$age.find('input[type=text]').each(function () {
					var $input = $(this);
					$input.attr('name', $input.attr('name').replace(index, newIndex));
					$input.attr('id', $input.attr('id').replace(index, newIndex));
				});

				$age.find('label').each(function () {
					var $label = $(this);
					$label.attr('for', $label.attr('for').replace(index, newIndex));
				});
			});
		};
		
		self.addAge = function () {
			var currentIndex = self.$ageList.find('.added').length,
				html = self.$ageTemplate.html().replace(/{{index}}/g, currentIndex);

			html = html.replace(/{{indexLabel}}/g, currentIndex + 1);

			var $html = $(html);
			$html.find('.index').text(currentIndex + 1);
			$html.insertBefore($(self.$ageList.find('li').last()));

			var $input = $html.find('input');
			$input.rules('add',
			{
				required: true,
				regex: '[0-9]*'
			});

			$input.on('blur', function () {
				$(this).valid();
			});
		};

		self.setupEventHandling = function() {
			self.$ageTemplate = self.$ervBody.find("#age-template");
			self.$ageList = self.$form.find('#added-ages');
			
			self.$form.find('#add-age').on('click', function (e) {
				e.preventDefault();
				self.addAge();
			});

			self.$ageList.on('click', '.age.added .remove-age', function (e) {
				e.preventDefault();
				self.deleteAge($(this).parents('.age.added'));
			});
		};

		self.$ervBody.find('[data-js = "maskingCPRNumber"]').on('input', function () {
			Masking.MaskingCPRNumber(this);
		});

		self.$ervBody.find('[data-js = "maskingCVRNumber"]').on('input', function () {
			Masking.MaskingCVRNumber(this, document.documentElement.getAttribute('data-domain'));
		});
	};

	Expatriate.prototype.init = function () {
		var self = this;

		var $button = self.$ervBody.find('.next-step');
		$button.on('click', function (e) {
			if (!$button.parents('form').valid()) {
				e.preventDefault();
				e.stopPropagation();
			}
		});

		self.setupEventHandling();
	}

	return Expatriate;
});